export default __webpack_public_path__ + "static/media/payment-failed.1625b22d.png";